if (!window.customElements.get("discount-copy")) {
  var DiscountCopy = class extends HTMLElement {
    constructor() {
      super();
      this._onCopyClick = this._onCopyClick.bind(this);
    }
    connectedCallback() {
      this._copyButtonEl = this.querySelector("[data-copied]");
      this._codeContentEl = this.querySelector("[data-code]");
      this._copyButtonEl?.addEventListener("click", this._onCopyClick);
    }
    disconnectedCallback() {
      this._copyButtonEl?.removeEventListener("click", this._onCopyClick);
      clearTimeout(this._copiedTimer);
      this._copyButtonEl?.setAttribute("data-copied", "false");
    }
    async _onCopyClick(event) {
      const el = event.currentTarget;
      const dataSuccess = el.getAttribute("data-copied");
      if (dataSuccess == "false" && this._codeContentEl && !this._copying) {
        const text = this._codeContentEl.getAttribute("data-code");
        if (!text || el.disabled) return;
        this._copying = true;
        try {
          await this._copyText(text);
          el.setAttribute("data-copied", "true");
          this._copiedTimer = setTimeout(() => {
            el.setAttribute("data-copied", "false");
          }, 3000);
        } catch (error) {
          console.warn('[discount-copy]: Copy failed', error);
        } finally {
          this._copying = false;
        }
      }
    }

    async _copyText(text) {
      try {
        await navigator.clipboard.writeText(text);
        return;
      } catch (error) {}

      const input = document.createElement('textarea');
      input.readOnly = true;
      input.value = text;
      input.style.cssText = 'position:fixed;top:0;left:0;opacity:0;pointer-events:none';
      document.body.appendChild(input);
      const activeElement = document.activeElement;
      try {
        input.select();
        input.setSelectionRange(0, text.length);
        if (!document.execCommand('copy')) throw new Error('Copy command failed');
      } finally {
        input.remove();
        activeElement?.focus({ preventScroll: true });
      }
    }
  };
  window.customElements.define("discount-copy", DiscountCopy);
}